import { render } from "./OpacityFadeInComponent.vue?vue&type=template&id=ff74bce0&ts=true"
import script from "./OpacityFadeInComponent.vue?vue&type=script&lang=ts"
export * from "./OpacityFadeInComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__